import $ from 'jquery';
import Viewport from './Viewport';

function MobileMenu(element) {
  this.element = element;
  this.$roots = this.getRootMenus();
  this.onClick = $.proxy(this.onClick, this);
  this.displayActiveMenus();
  this.listen();
}

MobileMenu.prototype = {
  getRootMenus() {
    return $('a.depth-1', this.element);
  },
  onClick(event) {
    const shouldExpand = $(event.target).is('.menu-link');
    if (Viewport.mobileState && shouldExpand) {
      $(event.currentTarget).toggleClass('expand');
      event.preventDefault();
    }
  },
  displayActiveMenus() {
    $('.active-trail a.depth-1:not(.active)', this.element).addClass('expand');
  },
  listen() {
    this.$roots.on('click', this.onClick);
  },
};

export default MobileMenu;



// WEBPACK FOOTER //
// ./MobileMenu.js